import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Clienti from "@/pages/Clienti";
import Depositi from "@/pages/Depositi";
import DepositoForm from "@/pages/DepositoForm";
import Magazzino from "@/pages/Magazzino";
import MagazzinoForm from "@/pages/MagazzinoForm";
import Import from "@/pages/Import";
import Login from "@/pages/Login";
import Audit from "@/pages/Audit";
import Scheda from "@/pages/Scheda";
import { isAuthed } from "@/lib/api";

const Protected = ({ children }) => (isAuthed() ? children : <Navigate to="/login" replace />);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="clienti" element={<Clienti />} />
            <Route path="depositi" element={<Depositi />} />
            <Route path="depositi/nuovo" element={<DepositoForm />} />
            <Route path="depositi/:id" element={<DepositoForm />} />
            <Route path="depositi/:id/scheda" element={<Scheda />} />
            <Route path="magazzino" element={<Magazzino />} />
            <Route path="magazzino/nuovo" element={<MagazzinoForm />} />
            <Route path="magazzino/:id" element={<MagazzinoForm />} />
            <Route path="import" element={<Import />} />
            <Route path="audit" element={<Audit />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            border: "2px solid #000",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
            fontWeight: 700,
            background: "#fff",
            color: "#000",
          },
        }}
      />
    </div>
  );
}

export default App;
